<template>
  <div class="wtb-container">
    <RouterView></RouterView>
  </div>
</template>

<script>

export default {
  name: "App",
};
</script>

<style lang="scss" scoped>
.wtb-container {
  max-width: 1140px;
  margin: 48px auto 0;
}

@media (max-width: 768px) {
  .wtb-container {
    margin-top: 12px;

  }
}
</style>